<template>
    <ul 
        class="shipping-methods__list"
        :class="{ 'shipping-methods__list--single': isSingleMethod }"
        tabindex="0" 
        :aria-label="$ml.get('ariaShippingTypeList')"
    >
        <li
            class="shipping-method__list-item"
            v-for="(method, index) in methods"
            :key="index"
            :class="{ 'shipping-method__list-item--active': isClicked == method.id }"
        >
            <button
                class="shipping-method"
                @click="shippingMethodId(method)"
                :disabled="isSingleMethod"
            >
                <div class="shipping-method__info-area">
                    <div class="shipping-method__icon">
                        <img :src="method.img" alt="" tabindex="-1" />
                    </div>

                    <div class="shipping-method__info">
                        <p>{{ method.description }}</p>
                        <span v-if="method.shippingTypeLoggi" v-text="$ml.get('within2Hours')" />
                        <span v-else-if="method.deadLine == 1" v-text="$ml.get('withinOneBusinessDay')" />
                        <span
                            v-else-if="method.deadLine >= 2"
                            v-text="$ml.with('0', method.deadLine).get('withinAnyBusinessDays')"
                        />
                    </div>
                </div>

                <div class="shipping-method__info-area">
                    <div class="shipping-method__price">
                        <span v-if="method.price != 0">{{ method.formattedPrice }}</span>
                        <span v-if="method.price == 0" class="free" v-text="$ml.get('free')" />
                    </div>
                </div>
            </button>
        </li>
    </ul>
</template>

<script>
import { mapGetters } from 'vuex';
import Swal from 'sweetalert2';

export default {
  name: 'ShippingPrice',

  data() {
      return {
          isClicked: null,
          isSingleMethod: false,
      };
  },

  computed: {
      ...mapGetters({
          methods: 'shippingType/getMethods',
          method: 'shippingType/getMethod'
      }),
  },

  mounted() {
        if (this.methods && this.methods.length === 1) {
            this.shippingMethodId(this.methods[0]);
            this.isSingleMethod = true;
        }

        this.isClicked = this.method && this.method.id;

        const methods = this.methods.filter(x => x.observation != null);

        if (methods != null && methods.length > 0) {
            Swal.fire(this.$ml.get('warning'), methods[0].observation);
        }
  },

  methods: {
      async shippingMethodId(payload) {
          this.isClicked = payload.id;
          await this.$store.dispatch('shippingType/setShippingMethodId', payload);
      }
  }
};
</script>

<style lang="scss" scoped>
  .shipping-methods {
      &__list {
          padding: 0;
          list-style-type: none;

          &:not(.shipping-methods__list--single) {
              .shipping-method {

                  &:hover,
                  &:focus {
                      background-color: #EFF1F3;
                  }
                  
                  &__list-item {
                    &:hover,
                    &--active {
                        background-color: #EFF1F3;
                    }

                    &--active {
                        .shipping-method__info {
                            p,
                            span {
                                color: #000000;
                            }
                        }
                    }
                  }
              }
              
          }
      }
  }
  .shipping-method {
      display: flex;
      align-items: center;
      justify-content: space-between;
      border: none;
      background-color: transparent;
      width: 100%;
      padding: 0px 0px 20px;

      &__list-item {
          background-color: #FFF;
          border-bottom: 1.5px solid #b8C1CC;
          transition: all .3s ease;
          cursor: pointer;
      
          &:not(:last-child) {
              margin-bottom: 20px;
          }
      }

      &__info-area {
          display: flex;
          align-items: center;
      }

      &__icon {
          margin-right: 12px;

          &,
          img {
              width: 24px;
              height: 24px;
          }

      }

      &__info {
          text-align: left;
          p {
              font-size: 16px;
              font-weight: 500;
              line-height: 16px;
              color: #2F363E;
              margin-bottom: 0;
          }

          span {
              font-size: 16px;
              font-weight: 600;
              line-height: 16px;
              color: #2F363E;
          }

      }

      &__price {
          font-size: 16px;
          font-weight: 600;
          line-height: 16px;
          color: #2F363E;

          .free {
              color: #00855D;
          }

      }
  }
</style>
